import React from 'react';
import Paper from 'material-ui/Paper';
import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui/Table';
import LongString from "../../common/LongString";
import Popover from "material-ui/Popover";
import theme from "../../../muiTheme";

const styles = {
  unitInfoContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  infoIcon: {
    color: theme.palette.primary1Color,
    margin: '0 4px',
    height: '18px',
    width: '18px',
    cursor: 'pointer'
  },
  popoverDl: {
    fontSize: '0.833em',
    margin: '0.66em'
  },
  unitIdAlias: {
    fontWeight: 'bold',
    paddingRight: '4px'
  }
};

const IncidentCardBasic = props => {
  function getContent(stats, labels) {
    if (!stats) {
      return null;
    }

    return generateCardTable(stats, labels);
  }

  function getTableRows(stats, labels) {
    return Object.keys(stats).map(key => {
      const label = labels[key];
      let value = stats[key];
      if (key === 'modifiedBySystems') {
        value = value.join(', ');
      }

      return (
        <TableRow selectable={false} key={label}>
          <TableRowColumn>{label} </TableRowColumn>
         <TableRowColumn> <LongString text={value} /></TableRowColumn>
        </TableRow>
      );
    });
  }


  function generateCardTable(stats, labels) {
    if (!stats) {
      return null;
    }

    return (
      <Table selectable={false}>
        <TableBody displayRowCheckbox={false}>
          {getTableRows(stats, labels)}
        </TableBody>
      </Table>
    );
  }

  return (
    <Paper>
      <h4 className="details-card-title">{props.title}</h4>
      {getContent(props.stats, props.labels)}
    </Paper>
  );
};

export default IncidentCardBasic;



// WEBPACK FOOTER //
// ./src/components/incidents/IncidentDetails/IncidentCardStats.js